(ns frontend.ui.component.card.view
  (:require
   [frontend.ui.component.heading.view :refer [h3]]
   [frontend.ui.component.icon.view :as icon-view]
   [frontend.ui.component.card.style :as style]
   [herb.core :refer [<class]]
   [frontend.utils :as fu]))

(defn card-head
  [{:keys [icon collapsed? disabled? on-click] :as props} title]
  [:div
   {:class    (<class style/head props)
    :on-click (when-not disabled? on-click)}
   [:div
    {:class (<class style/head-left)}
    icon
    [h3 title]]
   [icon-view/icon
    (if collapsed?
      :angle-down
      :angle-up)]])

(defn card-head-with-tools
  [{:keys [icon collapsed? disabled? on-click tools] :as props} title]
  [:div
   {:class    (<class style/head props)
    :on-click (when-not disabled? on-click)}
   [:div
    {:class (<class style/head-left)}
    icon
    [h3 title]]
   (into [:div
          {:class (<class style/head-right)}]
         tools)])

(defn card-body
  [{:keys [collapsed?]} child & children]
  (into [:div
         {:class (<class style/body collapsed?)}]
        (cons child children)))

(defn card
  [{:keys [title icon collapsed? hide-head? toggle-collapsed disabled?]}
   child & children]
  [:div
   {:class (<class style/card)}
   (when-not hide-head?
     [card-head
      {:icon       icon
       :collapsed? collapsed?
       :disabled?  disabled?
       :on-click   toggle-collapsed}
      title])
   (into [card-body {:collapsed? collapsed?}]
         (cons child children))])

(defn card-with-tools
  [{:keys [title tool-icons icon collapsed? disabled?]}
   child & children]
  [:div
   {:class (<class style/card)}
   [card-head-with-tools
    {:icon       icon
     :collapsed? collapsed?
     :disabled?  disabled?
     :tools      tool-icons}
    title]
   (into [card-body {:collapsed? collapsed?}]
         (cons child children))])
